import React from 'react';
import styles from './dashboard.module.scss';
import { KoText, KoTitle } from 'packages';
import KoIcon from '@kwapio/icons';

const chartConfigs = [
  { id: 'revenue', label: 'Revenue', icon: 'Revenueperemployee', arrow: 'ArrowLineUpFilled', description: '+$125 today', value: `$4,33,250` },
  { id: 'orders', label: 'Orders', icon: 'OrderBasketOutlined', color:'#FE5B65', arrow: 'ArrowLineUpFilled', description: '1,125 today', value: `1,321,800` },
  { id: 'customers', label: 'Customers', icon: 'Totalapplication', color:'#15AC77', arrow: 'ArrowLineUpFilled', description: '+756 today', value: `75,258` },
  { id: 'product', label: 'Product', icon: 'ProcessingOutlined', color:'#15AC77', arrow: 'ArrowLineUpFilled', description: '+0 today', value: `2,258` }
];

const DashboardStatus = ({ onCardClick, selectedChart }) => {
  return (
    <div className={styles.statusWrapper}>
      {chartConfigs.map(({ id, description , icon, arrow, label, value, color }) => (
        <div
          key={id}
          className={`${styles.card} ${selectedChart === id ? styles.activeCard : ''}`}
          onClick={() => onCardClick(id)}
        >
          <div className={styles.header}>
            <KoText className={styles.label} text={label} />
            <KoIcon name={icon} width={25} height={25} color={color ? color : '#fff'} />
          </div>
          <div className={styles.mycontent}>
            <div className={styles.count}>
              <KoTitle level={1} className={styles.value} text={value} />
            </div>
            <div className={styles.descriptionBox}>
              <KoText className={arrow ==='ArrowLineUpFilled' ?  styles.success : styles.budget} text='10%' />
              <KoIcon name={arrow} width={16} height={16} />
              <KoText className={styles.description} text={description} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStatus;
